<template>
  <div id="products">
    <h2 class="text-center">Portfolio</h2>
    <!-- Portfolio section-->
    <div class="row">
      <div class="col s12">
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/stationery.f0972cc2.jpg">
                <img
                  src="~@/assets/pics/stationery.jpg"
                  title="Stationery"
                  alt="sample"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/complimentary-card.a97b9e94.jpg">
                <img
                  src="~@/assets/pics/complimentary-card.jpg"
                  title="Complimentary Card"
                  alt="sample"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/stationery-1.3775aa97.jpg">
                <img
                  src="~@/assets/pics/stationery-1.jpg"
                  title="Stationery"
                  alt="sample"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/exercise-book.569f8a19.jpg">
                <img
                  src="~@/assets/pics/exercise-book.jpg"
                  alt="sample"
                  title="Exercise Book"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/sample-salad.1201053e.jpg">
                <img
                  src="~@/assets/pics/sample-salad.jpg"
                  alt="sample"
                  title="Restaurant Flyer"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/envelope.b580ca11.jpg">
                <img
                  src="@/assets/pics/envelope.jpg"
                  alt="sample"
                  title="Envelope"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/funeral-brochure.9a93f4ce.jpg">
                <img
                  src="~@/assets/pics/funeral-brochure.jpg"
                  alt="sample"
                  title="Funeral Brochure"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/invitation -card.c366b107.jpg">
                <img
                  src="~@/assets/pics/invitation -card.jpg"
                  alt="sample"
                  title="Invitation Card"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/delivery-flier.ba38c72c.jpg">
                <img
                  src="~@/assets/pics/delivery-flier.jpg"
                  alt="sample"
                  title="Flier for a delivery company"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/church-flier.bfb938fa.jpg">
                <img
                  src="~@/assets/pics/church-flier.jpg"
                  alt="sample"
                  title="Flier"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/invitation-card3.0726faf0.jpg">
                <img
                  src="~@/assets/pics/invitation-card3.jpg"
                  alt="sample"
                  title="Wedding Invitation Card"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="card hoverable">
            <div class="card-image">
              <a href="/img/t-shirt.dee294e4.jpg">
                <img
                  src="~@/assets/pics/t-shirt.jpg"
                  alt="sample"
                  title="T-shirt"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Portfolio section ends-->
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
h2 {
  text-decoration: underline;
  font-weight: 700;
}

img {
  width: 403px;
  height: 405px;
}

@media screen and (max-width: 601px) {
  img {
    width: auto;
    height: auto;
  }
}
</style>
